import { Box, Grid } from "@mui/material";
import React from "react";
import moment from "moment-timezone";
import getConsultationStatusByLang from "../../common/consultationStatusByLang";

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
const convertToTimeZone = (requestDate) => {
  const currentUserLang = localStorage.getItem("i18nextLng");
  let zone;
  zone = sessionStorage.getItem("timeZone");
  const date = moment(new Date(requestDate));
  if (["null", null, "undefined", undefined].includes(zone)) {
    zone = defaultZone;
  }
  return currentUserLang === "en"
    ? date
      .tz(zone.substring(zone.lastIndexOf(" ") + 1))
      .format("MM/DD/YYYY hh:mm:ss A")
    : date
      .tz(zone.substring(zone.lastIndexOf(" ") + 1))
      .format("DD/MM/YYYY hh:mm:ss A");
};

export const ConsultationDetails = ({ details, t }) => {
  const basicDetails = details && details.length > 0 ? details[0] : null;
  return (
    ![undefined, "undefined", null, "null", ""].includes(basicDetails) && (
      <Box style={{ height: '550px', overflow: 'auto' }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.Patient")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.user_name}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.Pharmacist")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.consultation_name}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.Store")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.store_name}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.Box")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.box_name}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.Date")}
          </Grid>
          <Grid item xs={6}>
            {![undefined, "undefined", null, "null", ""].includes(
              basicDetails.created_on
            )
              ? convertToTimeZone(basicDetails.created_on)
              : null}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.StartTime")}
          </Grid>
          <Grid item xs={6}>
            {![undefined, "undefined", null, "null", ""].includes(
              basicDetails.consult_start_date
            )
              ? convertToTimeZone(basicDetails.consult_start_date)
              : null}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.EndTime")}
          </Grid>
          <Grid item xs={6}>
            {![undefined, "undefined", null, "null", ""].includes(
              basicDetails.consult_end_date
            )
              ? convertToTimeZone(basicDetails.consult_end_date)
              : null}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.CallDuration")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.call_duration}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.PUCode")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.pickup_code}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.Status")}
          </Grid>
          <Grid item xs={6}>
            {getConsultationStatusByLang(basicDetails.Status, t)}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.ConsultationNotes")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.consultation_notes}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.OrderRelease")}
          </Grid>
          <Grid item xs={6}>
            {[true, "true"].includes(basicDetails.is_releaseorder)
              ? t("Global.Consultation.Action.Yes")
              : t("Global.Consultation.Action.No")}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.IDCapture")}
          </Grid>
          <Grid item xs={6}>
            {details && details.length > 0
              ? details.map((item, key) => {
                return <img style={{ width: '100%' }} alt={key} src={item.image_url} />;
              })
              : null}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.AcceptReject")}
          </Grid>
          <Grid item xs={6}>
            {[1, "1"].includes(basicDetails.type)
              ? t("Report.Consult.IsRejected")
              : t("Report.Consult.IsAccepted")}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Consult.RejectionReason")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.selected_reason}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Picked.PatientDetail.FirstName")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.first_name}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Picked.PatientDetail.LastName")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.last_name}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Picked.PatientDetail.IDNo")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.drivers_license_no}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Picked.PatientDetail.Relationship")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.relationship}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Picked.PatientDetail.ExpDate")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.expdate}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Picked.PatientDetail.IdType")}
          </Grid>
          <Grid item xs={6}>
            {basicDetails.card_type}
          </Grid>
        </Grid>
        <hr />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            {t("Report.Picked.PatientDetail.IDRawData")}
          </Grid>
          <Grid item xs={6}>
            <textarea style={{ resize: "vertical" }} cols={28} rows={8} readOnly>{basicDetails.dlrawdata}</textarea>
          </Grid>
        </Grid>
      </Box>
    )
  );
};



// WEBPACK FOOTER //
// ./src/components/reports/consultation/details.js